import dayjs from "dayjs";

export default {
    calcularAniosMeses: function (rango) {
        const [startStr, endStr] = rango.split('|');
        const start = dayjs(startStr, 'YYYY-MM-DD');
        const end = dayjs(endStr, 'YYYY-MM-DD').isValid() ? dayjs(endStr, 'YYYY-MM-DD') : dayjs();

        // Función auxiliar para el plural
        const plural = (cantidad, singular, pluralForm) => `${cantidad} ${cantidad === 1 ? singular : pluralForm}`;

        const totalMonths = end.diff(start, 'month');
        const totalDays = end.diff(start, 'day');

        // Si la diferencia es menor a un mes, mostrar en días
        if (totalMonths < 1) return `${totalDays} día${totalDays !== 1 ? 's' : ''}`;

        const years = Math.floor(totalMonths / 12);
        const months = totalMonths % 12;

        const partes = [
            years > 0 && plural(years, 'año', 'años'),
            months > 0 && plural(months, 'mes', 'meses')
        ].filter(Boolean);  // Elimina los valores nulos o undefined

        return partes.join(' y ');
    },
    formatearRangoFechas: function (rango) {
        const [startStr, endStr] = rango.split('|');


        const start = dayjs(startStr, 'YYYY-MM-DD');
        const end = dayjs(endStr, 'YYYY-MM-DD').isValid() ? dayjs(endStr, 'YYYY-MM-DD') : dayjs();

        // Formato para el mes con la primera letra en mayúscula
        const startFormatted = start.format('MMM YYYY');
        const endFormatted = end.format('MMM YYYY');

        const startCapitalized = startFormatted.charAt(0).toUpperCase() + startFormatted.slice(1);
        const endCapitalized = !dayjs(endStr, 'YYYY-MM-DD').isValid() ? 'Actual' : endFormatted.charAt(0).toUpperCase() + endFormatted.slice(1);

        return `${startCapitalized} - ${endCapitalized}`;
    },
    /*
     * Ordena un array de objetos por la fecha (de más reciente a más antigua).
     * La fecha se obtiene del segundo valor del split del símbolo `|` en la propiedad `fecha`.
     *
     * @param {Array<Object>} data - Array de objetos con la propiedad `fecha` en formato `YYYY-MM-DD|ACTUAL`.
     * @returns {Array<Object>} Array ordenado por fecha.
    */
    ordenarPorFechaInicial: function (data) {
        const getFechaFin = fechaStr => {
            const fin = fechaStr.split('|')[1];
            return fin.toLowerCase() === 'actual' ? dayjs() : dayjs(fin);
        };
        return data.sort((a, b) => {
            return getFechaFin(b?.fecha).diff(getFechaFin(a?.fecha));
        });
    },
    getPorcentajeAvanceCV: function (alumno) {
        const criterios = [
            { condition: alumno?.exp_laboral?.length > 0, value: 40 },
            { condition: alumno?.exp_academica?.length > 0, value: 15 },
            { condition: alumno?.habilidades?.some(h => h.tipo_habilidad === "TECNICAS"), value: 10 },
            { condition: alumno?.habilidades?.some(h => h.tipo_habilidad === "BLANDAS"), value: 15 },
            { condition: alumno?.idiomas?.length > 0, value: 10 },
            { condition: alumno?.software?.length > 0, value: 10 },
        ];

        return criterios.reduce((acc, { condition, value }) => condition ? acc + value : acc, 0);
    }
}